<template>
  <div>
    <div class="flex flex-wrap items-center justify-between pb-4 py-1">
      <div class="flex items-center space-x-4">
        <div class="relative">
          <button
            id="dropdownRadioButton"
            class="inline-flex items-center text-gray-400 bg-white border border-gray-300 rounded-md px-6 py-2"
            type="button"
            @click="toggleDropdown"
          >
            <svg
              class="w-6 h-6"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-width="2"
                d="M18.796 4H5.204a1 1 0 0 0-.753 1.659l5.302 6.058a1 1 0 0 1 .247.659v4.874a.5.5 0 0 0 .2.4l3 2.25a.5.5 0 0 0 .8-.4v-7.124a1 1 0 0 1 .247-.659l5.302-6.059c.566-.646.106-1.658-.753-1.658Z"
              />
            </svg>
            Filters
            <svg
              class="w-2.5 h-2.5 ms-2.5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 4 4 4-4"
              />
            </svg>
          </button>
          <!-- start dropdown filter -->
          <template v-if="currentTab === 'pharmacy-queue'">
            <div
              v-show="isDropdownOpen"
              id="filterDropdown"
              class="absolute z-10 mt-2 w-80 p-4 bg-white border border-gray-300 rounded-lg shadow-lg"
            >
              <div class="flex">
                <button
                  type="button"
                  class="ml-auto -mx-1.5 -my-1.5 p-1.5 inline-flex text-gray-500 items-center justify-end h-8 w-8 hover:text-custom-yellow"
                  @click="closeDropdown"
                  aria-label="Close"
                >
                  <span class="sr-only">Dismiss</span>
                  <svg
                    class="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                </button>
              </div>
              <form class="max-w-sm mx-auto" @submit.prevent="applyFilters">
                <div class="mb-4">
                  <label
                    for="priority"
                    class="block mb-2 text-sm font-medium text-gray-900"
                    >Status</label
                  >
                  <select
                    id="priority"
                    v-model="filters.status"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                  >
                    <option value="approved">Approved</option>
                    <option value="available">Available</option>
                    <option value="pending">Pending</option>
                    <option value="issued">Issued</option>
                  </select>
                </div>
                <div class="mb-4">
                  <label
                    for="dateRequested"
                    class="block mb-2 text-sm font-medium text-gray-900"
                    >Date Processed</label
                  >
                  <input
                    type="date"
                    id="dateRequested"
                    v-model="filters.dateRequested"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                  />
                </div>
                <div class="flex justify-end space-x-2">
                  <button
                    type="button"
                    @click="cancelFilters"
                    class="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-lg hover:bg-gray-100"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    class="px-4 py-2 text-sm font-medium text-white bg-custom-yellow rounded-lg hover:bg-custom-yellow-dark"
                  >
                    Filter
                  </button>
                </div>
              </form>
            </div>
          </template>
        </div>

        <div class="relative flex">
          <input
            type="text"
            v-model="filters.search_term"
            id="table-search"
            class="px-4 py-2 text-gray-700 border border-gray-300 rounded-sm dark:border-gray-300 dark:placeholder-gray-400"
            placeholder="Search"
          />
          <button
            @click="applyFilters"
            class="bg-custom-yellow text-white rounded-r px-2 md:px-3 py-0 md:py-1"
          >
            <svg
              class="w-6 h-6 text-gray-100 dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-width="2"
                d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="mt-4">
      <div class="flex gap-3">
        <!-- First Card -->
        <div class="w-full px-6 border border-gray-200 rounded-md">
          <div
            class="flex items-center px-1 py-3 bg-white rounded-md shadow-sm"
          >
            <div class="w-full">
              <div class="text-gray-500">Total Patients</div>
              <div class="flex items-center justify-between">
                <h4 class="text-2xl font-semibold text-gray-700">
                  {{ totalPatients }}
                </h4>
              </div>
            </div>
          </div>
        </div>
        <!-- Second Card -->
        <div class="w-full px-6 border border-gray-200 rounded-md">
          <div
            class="flex items-center px-1 py-3 bg-white rounded-md shadow-sm"
          >
            <div class="w-full">
              <div class="text-gray-500">Patients In Queue</div>
              <div class="flex items-center justify-between">
                <h4 class="text-2xl font-semibold text-gray-700">
                  {{ totalPrescriptions }}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tabs flex border-b mb-4">
      <button
        class="px-4 py-2 -mb-px font-semibold border-b-2"
        :class="{
          'border-custom-yellow text-custom-blue': currentTab === 'pharmacy-queue',
          'text-gray-500': currentTab !== 'pharmacy-queue',
        }"
        @click="currentTab = 'pharmacy-queue'"
      >
        Pharmacy Queue
      </button>
      <button
        class="px-4 py-2 -mb-px font-semibold border-b-2"
        :class="{
          'border-custom-yellow text-custom-blue': currentTab === 'issued-prescriptions',
          'text-gray-500': currentTab !== 'issued-prescriptions',
        }"
        @click="currentTab = 'issued-prescriptions'"
      >
        Issued Prescriptions
      </button>
    </div>

    <component
      :is="currentTabComponent"
      ref="currentTabComponent"
      :searchFilters="searchFilters"
      :search-query="searchQuery"
      @handle-totals="handleTotals"
      @close="closeAppointmentModal"
    ></component>
  </div>
</template>

<script>
import CustomButton from "@/components/CustomButton.vue";
import PharmacyQueueTab from "../tabs/PharmacyQueueTab.vue";
import IssuedPrescriptionsTab from "../tabs/IssuedPrescriptionsTab.vue";

export default {
  name: "PharmacyDashboardPage",
  components: {
    CustomButton,
    PharmacyQueueTab,
    IssuedPrescriptionsTab,
  },
  data() {
    return {
      currentTab: "pharmacy-queue",
      showPatientRegistrationModal: false,
      showNewAppointmentModal: false,
      totalPatients: null,
      totalPrescriptions: null,
      isDropdownOpen: false,
      searchFilters: {},
      filters: {
        status: "",
        search_term: "",
        dateRequested: "",
      },
    };
  },
  computed: {
    currentTabComponent() {
      switch (this.currentTab) {
        case "issued-prescriptions": return "IssuedPrescriptionsTab";
        default:                     return "PharmacyQueueTab";
      }
    },
  },
  created() {},
  methods: {
    applyFilters() {
      // Implement filter logic her
      // e
      const filters = this.filters;

      console.log("apply filters clicked");
      this.searchFilters = filters;
      this.closeDropdown();
    },
    cancelFilters() {
      this.filters = {
        dateRequested: "",
        status: "",
      };
      const filters = this.filters;

      console.log("apply filters clicked");
      this.searchFilters = filters;
      this.closeDropdown();
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    closeDropdown() {
      this.isDropdownOpen = false;
    },
    handleNewPatientRegistrationModal() {
      this.showPatientRegistrationModal = true;
    },
    handleNewAppointmentModal() {
      this.showNewAppointmentModal = true;
    },
    closePatientRegistrationModal() {
      this.showPatientRegistrationModal = false;
    },
    closeAppointmentModal() {
      this.showNewAppointmentModal = false;
    },
    handleTotals(totalPatients, totalPrescriptions) {
      this.totalPatients = totalPatients;
      this.totalPrescriptions = totalPrescriptions;
    },
  },

  mounted() {},
};
</script>

<style lang="css" scoped></style>
